import axios from "axios";

const axiosClient = axios.create({
  headers: {
    "Content-Type": "application/json",
    "Accept-Language": "en",
  },
});

export default axiosClient;
